export const MODULE_NAME = 'owner-booking'

export const NUXT_PAGE_OWNER_BOOKING_ICAL = 'owner-booking-ical'

export const NUXT_PAGE_OWNER_BOOKING_AVAIBOOK = 'owner-booking-avaibook'

export const NUXT_PAGE_OWNER_BOOKING_MISTERPLAN = 'owner-booking-misterplan'

export const NUXT_PAGE_OWNER_BOOKING_PLATFORMS = 'owner-booking-platforms'
